/** Bulk "Accept" is only safe for high/medium suggestions. Low-confidence
 *  matches are exactly where false positives hide, so they require an
 *  individual click on the row's Confirm button. */
export function isBulkAcceptable(confidence: string | null | undefined): boolean {
  const c = (confidence || '').toLowerCase();
  return c === 'high' || c === 'medium';
}
